import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type PromocodeGroupCreateResponseBody as SchemaPromocodeGroupCreateResponseBody } from '../schemas/PromocodeGroupCreateResponseBody';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Создает пустую группу промокодов в статусе черновика и возвращает её идентификатор
 * @tags PromocodeGroups
 * @summary Создание новой группы промокодов
 */
export const PromocodeGroupCreateContentType = '' as const;
export type PromocodeGroupCreateRequest = void;
export type PromocodeGroupCreateResponses = LinkCommonErrorResponses & {
    /**
     * @description Группа успешно создана
     */
    '200': {
        'application/json': SchemaPromocodeGroupCreateResponseBody;
    };
};
export type PromocodeGroupCreateResponseSuccess = PromocodeGroupCreateResponses['200']['application/json'];
export type PromocodeGroupCreateSearchParams = undefined;
export type PromocodeGroupCreatePathParameters = undefined;
export const PromocodeGroupCreateUrl = '/promocode_groups' as const;
export const PromocodeGroupCreateMethod = 'POST' as const;
export const getPromocodeGroupCreateUrl = (_params?: PromocodeGroupCreatePathParameters) => PromocodeGroupCreateUrl;
